import { memo } from 'react';
import type { Node } from 'react';

import classNames from 'classnames';

import svg from 'src/shared/app/base/component/template/assets/braindate.svg';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import BaseIcon from 'src/shared/ui/component/icon/BaseIcon';

import styles from './BraindateLogo.style';

type Props = {
  className?: string;
  title?: string;
};
const useStyles = createUseThemeStyles(styles);

const BraindateLogo = ({ className, title }: Props): Node => {
  const classes = useStyles();
  return (
    <BaseIcon
      className={classNames(classes.root, className)}
      svg={svg}
      title={title}
    />
  );
};

export default memo<Props>(BraindateLogo);
